import { useQuery } from '@tanstack/react-query';
import { ElementDocumentType } from 'components/element-viewer';
import { documentsAPI } from 'api/api';
import DocumentsButton from 'components/element-viewer/controls-panel-icon/DocumentsButton';
import React from 'react';
import { Box, useTheme } from '@mui/material';
import { useSelector } from 'react-redux';

export default function MenuGlobalDocuments({
    onChangeState = () => {},
}: {
    onChangeState?: (isOpened: boolean) => void;
}) {
    const { data } = useQuery<Array<ElementDocumentType> | void, Error>({
        queryKey: ['globalDocuments'],
        queryFn: () => documentsAPI.getGlobalDocuments(),
    });

    const userBrandThemeMenuProperties = useSelector((state: any) => state.auth?.userInfo?.brandThemeProperties?.menu);
    const themeEditorMenu = useSelector((state: any) => state.themeEditor.menu);
    const themeMenuSettings = { ...(userBrandThemeMenuProperties ?? {}), ...themeEditorMenu };
    const appTheme = useTheme();

    if (!data || data?.length == 0) {
        return null;
    }

    return (
        <>
            <Box className={'navbar-menu__root-item-component-icon'}>
                <DocumentsButton
                    docs={data}
                    popperSx={{
                        zIndex: 1601,
                        '.MuiPaper-root': {
                            borderTopLeftRadius: themeMenuSettings?.main_navigation == 'header' ? 0 : undefined,
                            borderTopRightRadius: themeMenuSettings?.main_navigation == 'left' ? 0 : undefined,
                        },
                        '.document-list__section-title, .document-list__item-label': {
                            fontFamily: appTheme.typography.topBarMenu.fontFamily as string,
                            fontWeight: appTheme.typography.topBarMenu.fontWeight as string,
                            textTransform: appTheme.typography.topBarMenu.textTransform as string,
                            fontStyle: appTheme.typography.topBarMenu.fontStyle as string,
                            fontSize: appTheme.typography.topBarMenu.fontSize as number,
                        },
                        '.document-list__section-title': {
                            fontWeight: () => {
                                if (
                                    ['700', 'bold'].includes(
                                        (appTheme.typography.topBarMenu.fontWeight ?? '').toString().toLowerCase(),
                                    )
                                ) {
                                    return 900;
                                }
                                return 700;
                            },
                        },
                    }}
                    onChangeState={onChangeState}
                    dataTest={'navbar-menu-documents-icon'}
                />
            </Box>
            <Box className={'navbar-menu__item-divider'} />
        </>
    );
}
